// extracted by mini-css-extract-plugin
module.exports = {"text":"PremiumMember-module_text_-7-gs","wrapper":"PremiumMember-module_wrapper_gmml6","mobile":"PremiumMember-module_mobile_2fEPr","icon":"PremiumMember-module_icon_HtoYN"};